//
//
//
//
//
//
import PdfH5 from "@/components/PreviewpdfH5";
export default {
  components: {
    PdfH5: PdfH5
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;

    var base64Str = this.$route.query.base64Str;
    var datas = 'data:application/pdf;base64,' + base64Str;
    this.$nextTick(function () {
      _this.$refs.PreviewpdfH5.openPdf(datas);
    });
  }
};